import { create } from 'zustand'
import {
  authenticationSlice,
  browserSlice,
  dailyViewSlice,
  dateJumpAlertSlice,
  eventsSlice,
  patientListSlice,
  reportsSlice,
  searchPatientsSlice,
} from './index'

const useBoundStore = create((...args) => ({
  ...authenticationSlice(...args),
  ...browserSlice(...args),
  ...dailyViewSlice(...args),
  ...dateJumpAlertSlice(...args),
  ...eventsSlice(...args),
  ...patientListSlice(...args),
  ...reportsSlice(...args),
  ...searchPatientsSlice(...args),
}))

export default useBoundStore
